exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-footer[data-v-3f05d280] {\n  text-align: center;\n  padding: 10px 0 20px;\n}\n", ""]);

// exports
